import React from "react";
import { UnifiedCreate } from "./UnifiedCreate/index";

const EnvironmentCreateWrapper: React.FC = () => {
  console.log('Route: /environment/new"');

  return <UnifiedCreate />;
};

export default EnvironmentCreateWrapper;
